export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["вчора"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Чат"])}
}